import EcoTextTc, { EcoTextTcItemProps } from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { tcLang } from './lang';
import getLocal from '@/app/utils/getLocal';

export default function Comp() {
    const { locale } = getLocal();
    const tcLanguage = tcLang[locale] || tcLang['eu'];

    const items = [
        {
            isHead: true,
            title: tcLanguage.head1,
        },
        {
            title: tcLanguage.titleA1,
            isOpen: true,
        },
    ];

    return <EcoTextTc items={items} className={styles.comp} />;
}
